import PageRoutes from './pageRoutes/PageRoutes';

const App = () => (
  <div>
    <PageRoutes />
  </div>
);

export default App;
